import { createAction, props } from '@ngrx/store';

export const setHttpLoadingStatus = createAction('[App State] Set HTTP loading status', props<{ isLoading: boolean }>());
export const addCustomLoader = createAction('[App State] Add custom loader', props<{ loaderName: string }>());
export const removeCustomLoader = createAction('[App State] Remove custom loader', props<{ loaderName: string }>());

export const changeLanguage = createAction(
  '[App State] Set language',
  props<{
    language: string;
  }>(),
);
